function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.923 25.23a1 1 0 01-1-1V10.462h22.154v13.77a1 1 0 01-1 1H4.923zm2-20.076v1.154h-2.77C3.518 6.308 3 6.825 3 7.462v16.692a2 2 0 002 2h20a2 2 0 002-2V7.462c0-.637-.517-1.154-1.154-1.154h-2.308v.23a1.154 1.154 0 11-2.307 0V5.154a1.154 1.154 0 00-2.308 0v1.154H11.54v.23a1.154 1.154 0 11-2.308 0V5.154a1.154 1.154 0 00-2.308 0zm11.77 8.077h-1.847v9.23h1.846v-9.23zm-7.385.923h1.846v8.308h-1.846v-8.308zm4.615.923h-1.846v7.385h1.846v-7.385zm-5.538 1.846H8.538v5.539h1.847v-5.539zm9.23-.923h1.847v6.462h-1.847V16z",
  fill: "currentColor"
})));